import { IonCard, IonCardContent, IonIcon, IonText } from '@ionic/react';
import { warningOutline } from 'ionicons/icons';

export const NegativeBudgetWarning = () => {
  return (
    <IonCard
      data-testid="negative-budget-warning"
      style={{ '--background': '#fff8e1', '--color': '#b45309' }}
    >
      <IonCardContent>
        <div className="flex items-start gap-3">
          <IonIcon
            icon={warningOutline}
            className="text-2xl flex-shrink-0"
            style={{ color: '#b45309' }}
          />
          <div>
            <IonText>
              <p className="font-semibold" style={{ color: '#b45309' }}>
                Presupuesto negativo
              </p>
              <p className="text-sm" style={{ color: '#92400e' }}>
                El equipo tenía presupuesto negativo en esta jornada.
              </p>
            </IonText>
          </div>
        </div>
      </IonCardContent>
    </IonCard>
  );
};
